export default __webpack_public_path__ + "static/media/odin.0e8f9818.png";